export const dietTypes = [
    {type: "Wet", value: "canned"},
    {type: "Dry", value: "dry"},
    {type: "Treats", value: "treats"},
];
export const diets = [
    "Wet",
    "Dry",
    "Treats"
];
